import Service from "@/utils/api/service";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
  name: "EditWarehouse",
  data() {
    return {
      isCreating: false,
      body: {
        name: "",
        description: "",
        code: "",
      },
    };
  },
  components: {
    Multiselect,
  },
  computed: {
    ...mapState(["permissions"]),
  },
  created() {
    this.getWarehouse();
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "ListWarehouse",
      });
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    getWarehouse() {
      Service.getWarehouse(this.$route.query.id).then((response) => {
        this.isFetching = false;

        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getWarehouse();
              }
            });
          } else {
            this.isDescription = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.body = {
            name: response.data?.name || "",
            description: response.data?.description || "",
            code: response.data.code,
          };
        }
      });
    },

    onSubmit() {
      let validatedMessage = this.validateBody(this.body);

      if (validatedMessage == "ok") {
        this.isCreating = true;
        this.onConfirm();
      } else {
        this.$toasted.show(validatedMessage);
      }
    },

    validateBody(data) {
      if (!data.name) {
        return "Name cannot be empty!";
      }

      if (!data.code) {
        return "Code cannot be empty!";
      }

      return "ok";
    },

    onConfirm() {
      const body = {
        name: this.body.name,
        code: this.body.code,
        description: this.body.description,
      };

      Service.updateWarehouse(this.$route.query.id, body).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.onConfirm();
              }
            });
          } else {
            this.isCreating = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.isCreating = false;
          this.goBack();
          this.$toasted.show("Warehouse has been updated.");
        }
      });
    },

    resetBody() {
      this.body = {
        name: "",
        description: "",
        code: "",
      };
    },
  },
};
